import React from 'react';
import './styles.css';
import Views from "./components/views";

const MenuItemCategories = () => {

  return (<Views/>);
};

export default MenuItemCategories;